// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import {useEffect, useState} from 'react';
import {i_user_info} from 'hola_app_context';
import etask from 'zetask';
import {api} from './api';

export interface i_transaction {
    id: string;
    subscr_id?: string;
    amount: number;
    currency: string;
    gateway: string;
    status: string;
    type: string;
    ts: string;
    test: boolean;
    invoice_url?: string;
}
export interface i_product {
    amount: number;
    client_id: string;
    id: string;
    period: string;
    plan_id: string;
    quantity: number;
    unit: 'gb' | 'ip';
    next_payment_ts: string
}
export interface i_payment {
    ts: string;
    amount: number;
    limit: number;
    currency: string;
    status: 'success' | 'error';
    ccard_last4: string;
    ccard_type: string;
}
export type subscription = {
    subscr_id: string;
    payments: i_payment[];
    product: i_product;
}
export type t_account_data = {
    active_subscriptions?: subscription[];
    transactions?: i_transaction[];
    inited: boolean;
};

export const use_account_data = (user: i_user_info, init: boolean)=>{
    const [data, set_data] = useState<t_account_data>(()=>({
        inited: false,
    }));
    useEffect(()=>{
        if (!user || !init)
            return;
        refresh_data();
    }, [!!user, init]);
    const refresh_data = ()=>{
        etask(function*(){
            const response = yield api.get_account_bootstrap();
            if (response.subscriptions || response.transactions)
            {
                set_data(val=>({
                    ...val, inited: true,
                    active_subscriptions: response.subscriptions ?? [],
                    transactions: response.transactions ?? [],
                }));
            }
        });
    };
    return {data, refresh_data};
};
